export const MainWrapper = (font: string) =>
  `block sticky ${font} font-medium uppercase leading-12 text-center text-white fill-white w-full text-10 md:text-12 pb-6 md:pb-0 px-5 md:px-10 z-50 overflow-hidden min-h-[34px] max-h-[46px] top-0 transform transition duration-500`

export const NewsContentWrapper =
  'pr-5 md:px-20 block overflow-hidden relative top-[11px] left-0 min-h-[12px] md:max-h-[12px] max-h-6 tracking-1 md:tracking-1.2 leading-12'

export const CloseIcon =
  'absolute flex h-full top-0 items-center right-5 text-center cursor-pointer'
